import { motion } from "motion/react";

export default function TopWantedHeader({ header }) {
  return (
    <motion.header
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="mx-auto max-w-4xl py-10 text-center sm:py-12 lg:py-14"
    >
      <p className="text-xs font-black uppercase tracking-[0.34em] text-muted-foreground">
        {header.eyebrow}
      </p>

      <h1 className="mt-4 text-4xl font-black uppercase tracking-[-0.04em] sm:text-5xl lg:text-6xl">
        {header.title}
      </h1>

      <p className="mt-3 text-base font-semibold text-foreground sm:text-lg">
        {header.subtitle}
      </p>

      <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-muted-foreground sm:text-base">
        {header.description}
      </p>
    </motion.header>
  );
}
